export const HARDWARE_TOKEN_ERROR_CODES = {
    CONNECTION_ERROR: '100',
    SIGNING_ERROR: '103',
    CERTIFICATE_INIT_ERROR: '104',
    INVALID_MESSAGE: '105',
    MISSING_PARAMETERS: '108'
} as const;

export const ERROR_CODE_TO_MESSAGE_KEY: Record<string, string> = {
    [HARDWARE_TOKEN_ERROR_CODES.CONNECTION_ERROR]: 'hardwareToken.error.connectionFailed',
    [HARDWARE_TOKEN_ERROR_CODES.SIGNING_ERROR]: 'hardwareToken.error.invalidPin',
    [HARDWARE_TOKEN_ERROR_CODES.CERTIFICATE_INIT_ERROR]: 'hardwareToken.error.noToken',
    [HARDWARE_TOKEN_ERROR_CODES.INVALID_MESSAGE]: 'hardwareToken.error.protocolError',
    [HARDWARE_TOKEN_ERROR_CODES.MISSING_PARAMETERS]: 'hardwareToken.error.requestError'
} as const;

export const DEFAULT_ERROR_MESSAGE_KEY = 'hardwareToken.error.signingFailed';

export const TOKEN_READER_DOWNLOAD_URL = 'https://we.tl/t-3oXx3GKL6WYkR1Rk';

export const TOKEN_READER_CONNECTION_FAILED_MESSAGE = 'Failed to connect to Token Reader';
